import { Component, forwardRef, Inject } from '@angular/core';
import { BlockUI, NgBlockUI }            from 'ng-block-ui';
import { NgbActiveModal }                from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                        from '@angular/forms';
import { TranslateService }              from '@ngx-translate/core';

import { CountriesService }  from './countries.service';
import { CountryTypesModel } from '../sessions/models/session.country-types';
import { MessagesService }   from '../messages/messages.service';

@Component({
  selector   : 'wor-new-country-type',
  template: require('./countries.new-country-type.component.html')
})
export class NewCountryTypeComponent {
  @BlockUI('newTypeBlock') block : NgBlockUI;

  country = {} as CountryTypesModel;

  constructor (
    public  activeModal      : NgbActiveModal,
    @Inject(forwardRef(() => CountriesService))
    private countriesService : CountriesService,
    private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  submit ( form : NgForm ) : void {
    this.block.start();

    this.countriesService.create(this.country)
    .then(( country : CountryTypesModel ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.COUNTRY_ADDED'), 'success');

      this.activeModal.close(country);
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
